import { makeStyles } from 'tss-react/mui';

const useProductDetailsAddOrderButtonV2Styles = makeStyles()((theme) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: theme.spacing(0.25),
    borderRadius: theme.shape.borderRadiusLg,
    transition: theme.transitions.create(['background-color', 'color']),
  },
  mediumWidth: {
    minWidth: 45,
  },
  largeWidth: {
    minWidth: 60,
  },
}));

export default useProductDetailsAddOrderButtonV2Styles;
